module.exports = __webpack_public_path__ + "img/08964014000137.7a9b61ec.png";